<template>
  <main class="thanks">
    <div class="message thanks-message">
      <div class="thanks-inner">
        <h2 class="title">ご回答ありがとうございました。</h2>
        <div class="txt">
          こちらでご質問は以上となります
          <br />
          担当者からご連絡をさせていただきますので今しばらくお待ちくださいませ
        </div>
        <div style="margin-top: 48px;">
          <a
            href="/"
            style="display: inline-block; padding: 16px 48px; background: #fff; color: #1877b2; border: 2px solid #1877b2; border-radius: 4px; font-weight: bold; font-size: 16px; text-decoration: none;"
          >
            公式サイトTOP
          </a>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'LpThanks',
  props: {
    imagePaths: { type: Object, default: () => ({}) }
  }
}
</script>
